var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-review-list"},_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"list"},[_c('div',[_c('span',[_vm._v("\n\t\t\t\t"+_vm._s(_vm.utils.replaceStr(item.username))+"\n\t\t\t\t"),_c('span',{class:{
						'good-review': item.grade == 3,
						'medium-review': item.grade == 2,
						'bad-review': item.grade == 1
					}},[_vm._v(_vm._s(_vm.getGrade(item.grade)))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getTime(item.created_at)))])]),_vm._v(" "),(item.content)?_c('p',[_vm._v(_vm._s(item.content))]):_vm._e(),_vm._v(" "),(!item.content)?_c('p',[_vm._v("无评价信息")]):_vm._e()])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e76250a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/product-detail/child/ReviewList.vue
// module id = null
// module chunks = 